/* global AdressCheck */

(function () {
	const adressCheckData = $(document.currentScript).data();

	$('#SelectedLaenderkennzeichenValue')
		.on('change', function () {
			$('#SelectedLaenderkennzeichenName').val($(this).children().filter(':selected').text());
		})
		.triggerHandler('change');

	if (adressCheckData.mitStrassendatenbankAbgleichen) {
		window.adressCheck = new AdressCheck(
			adressCheckData.liefereStrassenUrl,
			adressCheckData.liefereOrteUrl,
			adressCheckData.lieferePlzsUrl,
			adressCheckData.adresseGueltigUrl,
			undefined,
			adressCheckData.idForStrasse,
			adressCheckData.idForHausnummer,
			adressCheckData.idForOrt,
			adressCheckData.idForPlz,
			adressCheckData.strassendatenvorschlagAbXZeichen
		);
	}
})();
